export {
  defineLocale,
  getSetGlobalLocale,
  listLocales
} from './locale/locales.service';
